// src/utils/toastConfig.js
import { POSITION } from 'vue-toastification'

const toastOptions = {
    position: POSITION.TOP_CENTER,
    closeOnClick: false,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    hideProgressBar: false,
    allowHtml: true
    // Add other configurations as needed
}

export default toastOptions
